import React from 'react';
import SkillItem from './SkillItem';
import skills from './SkillsFile';

export const Skills = () => {
  const sortedSkills = skills.slice().sort((a, b) => a.title.localeCompare(b.title));

  return (
    <section className="skill" id="skills">
      <div className="container">
        <div className="skill-bx">
          <h2>Skills</h2>
          <p>
            Over the years I've built up a broad toolkit spanning backend systems, automation,
            computer vision, and web development. Here's a look at what I work with.
          </p>
          <div className="row">
            {sortedSkills.map(skill => (
              <SkillItem key={skill.id} title={skill.title} svg={skill.svg} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
